import {createAction, handleActions} from 'redux-actions';

// - Actions
export const addCustomer = createAction('CUSTOMER_ADD', customer => customer);
export const removeCustomer = createAction('CUSTOMER_REMOVE');
export const saved = createAction('CUSTOMER_SAVED');
export const ageConfirmed = createAction('AGE_CONFIRMED');
// - State
const initialState = {
  firstName: 'John',
  lastName: 'Appleseed',
  driverLicenseId: '123456789X',
  isDetailsSaved: false,
  isAgeConfirmed: false,
};
// - Reducers
export default handleActions({
  CUSTOMER_ADD: (state, action) => {
    const customer = action.payload;
    return customer;
  },
  CUSTOMER_REMOVE: (state, action) => initialState,
  CUSTOMER_SAVED: (state, action) => ({...state, isDetailsSaved: true}),
  AGE_CONFIRMED: (state, action) => ({...state, isAgeConfirmed: true}),
}, initialState);

// - Selectors
export const getFullName = (state) => {
  const fullName = [state.customer.firstName, ' ', state.customer.lastName];
  return fullName.join('');
};
export const getDlId = (state) => state.customer.driverLicenseId;
export const isSaved = (state) => state.customer.isDetailsSaved;



// WEBPACK FOOTER //
// ./src/reducers/customerReducer.js